import { Alert } from "../utils";


class IdentityUtils {
validateIdentity = val => {
  let total = 0;
  let iPID = val.replace(/-/g, "");
  let chk;
  let Validchk;
  Validchk = iPID.substr(12, 1);
  let j = 0;
  let pidcut;
  for (let n = 0; n < 12; n++) {
    pidcut = parseInt(iPID.substr(j, 1));
    total = total + pidcut * (13 - n);
    j++;
  }

  chk = 11 - (total % 11);
  if (chk == 10) {
    chk = 0;
  } else if (chk == 11) {
    chk = 1;
  }

  if (chk != Validchk) {
    Alert.alertWithTitle(
      "กรุณาทำรายการใหม่อีกครั้ง",
      "ระบุหมายเลขประจำตัวประชาชนไม่ถูกต้อง",
      "warning"
    );
    // alert("ระบุหมายเลขประจำตัวประชาชนไม่ถูกต้อง");
    return false;
  }
  return true;
  // console.log(checkID(val));
  // if(!checkID(val)) {
  //     alert('รหัสประชาชนไม่ถูกต้อง');
  //     return false
  // }
  // return true
};

checkID(id) {
  if (id.length != 13) return false;
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseFloat(id.charAt(i)) * (13 - i);
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;
    return true;
  }
}

validateEmail = val => {
  const regex = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
  if (regex.test(val)) {
    return true;
  } else {
    Alert.alertWithTitle(
      "กรุณาทำรายการใหม่อีกครั้ง",
      "ระบุอีเมลไม่ถูกต้อง",
      "warning"
    );
    // alert("ระบุอีเมลไม่ถูกต้อง");
    return false;
  }
};
}
export default new IdentityUtils();